module.exports = __webpack_public_path__ + "img/privacidad_aviso-3.50039095.jpg";